module.exports = __webpack_public_path__ + "static/media/reddit.6ad6391d.svg";